import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import "../styles/components/_blogs.scss";
import { Link } from "react-router-dom";
import blogBg from '../assets/images/blog-bg.jpg';
import { Helmet } from "react-helmet";


const Blogs = () => {
  const [blogs, setBlogs] = useState([]); // State to store blog data

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const testCollection = await db.collection("posts").get();
        // console.log(testCollection) // Log the collection reference
        const blogsData = testCollection.docs.map((doc) => ({
          id: doc.id,
          title: doc.data().title,
          description: doc.data().description,
          ...doc.data(),
        }));
        // console.log(blogsData) // Return the entire document
        setBlogs(blogsData); // Update the state with fetched documents
      } catch (error) {
        console.error("Error connecting to Firestore:", error);
      }
    };

    fetchBlogs();
  }, []);

  return (
    <div className="our-blogs"
      style={{
        // height: "100vh",
        backgroundImage: `url(${blogBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <Helmet>
        <title>Blogs - Mevedir</title>
      </Helmet>
      <div className="small-width" >
        <div className="blog-page">
          <h1 className="blog-title">Our Blogs</h1>
          <p className="blog-subtitle">Discover our Blogs</p>
          <div className="blog-cards">
            {blogs.map((blog) => (
              <div className="blog-card" key={blog.id}>
                <div className="blog-image">
                  <img
                    src={
                      blog.mainImage ||
                      "https://vartohorganic.com/storage/blog-images/ChatGPT%20Image%20Apr%2011,%202025,%2010_48_32%20AM.webp"
                    }
                    alt={blog.title}
                  />
                </div>
                <div className="blog-content">
                  <span className="blog-category">
                    {blog.category || "Category"}
                  </span>
                  <h2 className="blog-card-title">{blog.title}</h2>
                  <p className="blog-description">
                    {blog.description.split(" ").slice(0, 20).join(" ")}
                    {blog.description.split(" ").length > 20 && "..."}
                  </p>
                  <div className="blog-meta">
                    <span>
                      {blog.readTime ? `${blog.readTime} min read` : ""}
                    </span>
                    <span>
                      {blog.createdAt
                        ? new Date(
                            blog.createdAt.seconds
                              ? blog.createdAt.seconds * 1000
                              : blog.createdAt
                          ).toLocaleDateString()
                        : ""}
                    </span>
                  </div>
                  <Link to={`/blogs/${blog.slug}`}>
                    <p className="blog-link">
                      Read Article <span>→</span>
                    </p>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blogs;
